import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { NavigationModule } from "navigation/navigation.module";
import { ResetPassword } from "./reset-password";
@NgModule({
  declarations: [ResetPassword],
  imports: [
    IonicPageModule.forChild(ResetPassword),
    TranslateModule.forChild(),
    NavigationModule,
    CommonComponentsModule,
  ],
  entryComponents: [ResetPassword],
  exports: [ResetPassword],
})
export class ResetPasswordCognitoModule {}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/reset-password-cognito/reset-password.module.ts